// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__yYbhy","loaderWhite":"loader_loaderWhite__eTShj","loader-white":"loader_loader-white__t5YUY"};